import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=ef0d8fda&scoped=true&"
import script from "./CompanyCard.vue?vue&type=script&lang=js&"
export * from "./CompanyCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCard.vue?vue&type=style&index=0&id=ef0d8fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0d8fda",
  null
  
)

export default component.exports